import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import "../Dashboard/Dashboard.css";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../Model/AskpageNumber";
import Pagination from "../../utils/Pagination";
import { v4 as uuid } from "uuid";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin, requestLoading } from "../../utils/comman/Common";
import { ShowAllDetails } from "../Model/ShowAllDetails";
import { setpageContent } from "../../utils/Constant";

const Payoutservice = () => {
  const requesterId = useSelector(
    (state) => state.selectedretailerReqesterReducer.requesterId
  );
  
  const [isExportable, setIsExportable] = useState(false);
  const [axiosInstance] = axiosinstances();
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [showModal, setShowModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstSelectedPage, setFirstSelectedPage] = useState();
  const [secondSelectedPage, setSecondSelectedPage] = useState();
  const [selectOption, setSelectOption] = useState("");
  const [customPage, setCustomPage] = useState("");
  const [selectedPage, setSelectedPage] = useState(1);
  const [search, setsearch] = useState("");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pageStart, setpageStart] = useState(0);
  const [pagelimit, setPagelimit] = useState(0);
  const [isclearClicked, setIsclearClicked] = useState(false);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [showDetails, setShowDetails] = useState({ show: false, indexs: -1 });
  const [table, settable] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedDataToShow, setSelectedDataToShow] = useState({});
  const [showModalDetails, setShowModelDetails] = useState(false);

  const a = useSelector((state) => state.transactionhistoryreducer.Transaction);
  const fetchpagedata = async (pageindex, id, isAdmin, selectedId) => {
    setDataLoading(true);
    setsearch("");
    const response = await axiosInstance
      .post(
        `/api/v1/payout/order/history`,
        {
          header: {
            "client-id": id, // client id will admin id
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            "requestId" : uuid(),
            time: new Date(),
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          // status:
          //   finalSelectedStatus !== undefined &&
          //   finalSelectedStatus.length !== 0
          //     ? finalSelectedStatus
          //     : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        //console.log("res", res);
        settable(res.data.list);
        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: res.data?.totalElements,
            totalPages: res.data?.totalPages,
          };
        });
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        setIsDataLoaded(false);
        toast.error("Something went wrong");
      });
  };
 
  useEffect(() => {
    if (isclearClicked) {
      callApi();
    }
  }, [isclearClicked]);
  const handalpageclick = async (index) => {
    setPaginationDetails((prev) => {
      return { ...prev, currentPage: index };
    });
    const callapiindex = await fetchpagedata(
      index - 1,
      id,
      isUserAdmin(id),
      selectedId
    );
  };

  useEffect(() => {
    if (id && isUserAdmin(id)) {
      handalpageclick(1);
    } else if (id && !isUserAdmin(id)) {
      handalpageclick(1);
    }
  }, [id, selectedId]);
  useEffect(() => {
    if (selectOption === "All" && firstSelectedPage !== undefined) {
      setpageStart(1);
      setPagelimit(firstSelectedPage);
    } else if (
      selectOption == "Custom" &&
      firstSelectedPage !== undefined &&
      secondSelectedPage !== undefined
    ) {
      setpageStart(firstSelectedPage);
      setPagelimit(secondSelectedPage);
    }
  }, [selectOption, firstSelectedPage, secondSelectedPage]);
  const totalpage = paginationDetails.totalPages;
  const e = JSON.parse(sessionStorage.getItem("token"));

  const searchdata = async () => {
    setsearch((search) => {
      return search;
    });
    const callingsearchapi = await searchapidata(search, id);
    //console.log('callingsearchapi', callingsearchapi)
    settable(() => callingsearchapi.list);
  };
  const callApi = () => {
    if (isUserAdmin(id) && selectedId !== null) {
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
    } else {
      fetchpagedata(0, id, isUserAdmin(id));
    }
  };
  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    callApi();
  };
  const txnFromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const txnToDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const checkDisable = () => {
    let disabled = true;
    if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };
  const resetApply = () => {
    // setFinalSelectedStatus([]);
    // setSelectedStatus([]);
    setIsExportable(false);
    setFormDate("");
    setToDate("");
    setIsclearClicked(true);
  };
  const searchapidata = async (search) => {
    const trimSearch = search.trim();
    const response = await axiosInstance
      .get(`/api/v1/payout/order/search/${trimSearch}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        settable(res.data.list);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const enterTxnsearch = (event) => {
    event.preventDefault();

    setsearch(event.target.value);
  };
  const onExportData = () => {
    setShowModel(true);
  };

  const closePopUp = () => {
    setShowModel(false);
    setSelectedPage(1);
  };
  const fetchpagedataInloop = async (pageindex, id, isAdmin, selectedId) => {
    setDataLoading(true);
    setsearch("");
    const response = await axiosInstance
      .post(
        `/api/v1/payout/order/history`,
        {
          header: {
            "client-id": id, // client id will admin id
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            time: new Date(),
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          // status:
          //   finalSelectedStatus !== undefined &&
          //   finalSelectedStatus.length !== 0
          //     ? finalSelectedStatus
          //     : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        setDataLoading(false);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        setIsDataLoaded(false);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  async function exportAllFile() {
    setLoading(true);
    let result = [];
    // console.log("limit", pageStart, pagelimit);
    for (let i = pageStart - 1; i < pagelimit; i++) {
      const data = await fetchpagedataInloop(
        i,
        id,
        isUserAdmin(id),
        selectedId
      );
      if (Array.isArray(data?.list)) {
        const unwantedHeaderForExcel = data.list.map((val) => {
          val.customer_Name = val?.customer?.name;
          delete val.customer;
          delete val.beneficiary;
          delete val.transaction;
          delete val.origTxn;
          delete val.finalTxn;
          delete val.subOrders;
          delete val.changeLog;
          delete val.channel;
          delete val.optional;
          delete val.txnDetails;
          const newvalues = val;
          return newvalues;
        });
        result.push(...unwantedHeaderForExcel);
      }
    }
    setLoading(false);
    const csv = convertArrayToCSV(result);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "data.csv");
    closePopUp();
    setLoading(false);
  }
  const clearSearch = () => {
    setsearch("");
    handalpageclick(1);
  };
  const showDetailsHandler = (index) => {
    if (showDetails.show && showDetails.indexs === index) {
      setShowDetails({ show: false, indexs: -1 });
    } else {
      setShowDetails({ show: true, indexs: index });
    }
  };
  const showAllData = (data) => {
    setSelectedDataToShow({ ...data });
    setShowModelDetails(true);
  };
  const closeDetailsPopUp = () => {
    setShowModelDetails(false);
  };
  let orderAmount = 0;
  let orderSurcharge = 0;
  let transactionAmount = 0;
  let transactionSurcharge = 0;
  //console.log("table", table);
  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <AskpageNumber
            showModal={showModal}
            closePopUp={closePopUp}
            totalpage={totalpage}
            setFirstSelectedPage={setFirstSelectedPage}
            firstSelectedPage={firstSelectedPage}
            exportAllFile={exportAllFile}
            secondSelectedPage={secondSelectedPage}
            setSecondSelectedPage={setSecondSelectedPage}
            selectOption={selectOption}
            setSelectOption={setSelectOption}
            customPage={customPage}
            setCustomPage={setCustomPage}
          />
          <ShowAllDetails
            showModal={showModalDetails}
            closePopUp={closeDetailsPopUp}
            data={selectedDataToShow}
          />
          <div class="mid">
            <div class="container-fluid">
              <div class="maincard">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link active"
                    id="mobile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-mobi"
                    type="button"
                    role="tab"
                    aria-controls="nav-mobi"
                    aria-selected="true"
                  >
                   Payout Transactions
                  </button>
                  {/* <button
                class="nav-link"
                id="mobi-grap-tab"
                data-bs-toggle="tab"
                data-bs-target="#mobi-grap"
                type="button"
                role="tab"
                aria-controls="mobi-grap"
                aria-selected="false"
              >
                Analytics
              </button> */}
                </div>

                <div class="tab-content" id="mobiletab">
                  <div
                    class="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <div class="head">
                      {/* <h3>Payout History</h3> */}
                      <div class="dropdown fltr">
                        <button
                          type="button"
                          title="Filter"
                          class="filter dropdown-toggle"
                          id="fillist"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="false"
                          aria-expanded="false"
                          // style={{border:'2px solid rgb(132, 133, 135)'}}
                        >
                          Filter
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-end"
                          id="filterbox"
                          aria-labelledby="fillist"
                        >
                          <form onSubmit={applyStatus}>
                            <div class="filters">
                              <label for="select-state">From Date:</label>
                              <input
                                type="date"
                                onChange={txnFromDateHandler}
                                value={formDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={txnToDateHandler}
                                value={toDate}
                              />
                            </div>
                            <div class="fbtn">
                              <button
                                class="btn"
                                type="submit"
                                id="btnapply"
                                disabled={checkDisable()}
                              >
                                Apply
                              </button>
                              <button
                                class="btn"
                                type="reset"
                                id="btnclear"
                                onClick={resetApply}
                              >
                                Clear
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div class="headsearch">
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            onChange={(event) => enterTxnsearch(event)}
                            placeholder="Search transaction..."
                            value={search}
                          />
                          <button
                            class="btn search"
                            disabled={search.length <= 3}
                            type="button"
                            id="txnsrch"
                            onClick={searchdata}
                          >
                            search
                          </button>
                          <button
                            style={{ background: "#FF8D33", marginLeft: "3px" }}
                            class="btn delete"
                            // disabled={search.length <= 3}
                            type="button"
                            onClick={clearSearch}
                          >
                            clear
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            table?.map((data, index) => {
                              const maskAllButLastFour =
                                data?.beneficiary?.account?.accNum.replace(
                                  /[0-9](?=([0-9]{4}))/g,
                                  "*"
                                );
                              return (
                                <div
                                  class="txn-item"
                                  key={data.id}
                                  onClick={() => showDetailsHandler(index)}
                                >
                                  <div class="txn-head" id={`txnhead${index}`}>
                                    <div
                                      class="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#txn${index}`}
                                      aria-expanded="false"
                                      aria-controls={`txn${index}`}
                                    >
                                      <div
                                        class={`txncard ${
                                          data.status === "SUCCESS"
                                            ? "success grbg"
                                            : `${
                                                data.status === "PENDING" ||
                                                data.status === "PROCESSING" ||
                                                data.status === "HUNG" ||
                                                data.status === "ACCEPTED"
                                                  ? "pending ylbg"
                                                  : "failed rdbg"
                                              }`
                                        }`}
                                      >
                                        <div class="row">
                                          <div class={`col-12 ${ ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? "col-md-4" : "col-md-5"}`}>
                                            <div class="txntxt">
                                              <h5>
                                                <h6>Txn ID: {data.id}</h6>
                                              </h5>
                                            </div>
                                            <div class="txntxt">
                                              <h6>
                                                Beneficiary's Name:{" "}
                                                {data?.beneficiary.name}
                                              </h6>
                                            </div>
                                          </div>
                                          {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                          <div class="col-12 col-md-4">
                                            <div class="txntxt">
                                              <h6>
                                                Request ID: {data.requestId}
                                              </h6>
                                              { ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? 
                                              <h6>
                                              Agent Id:{" "}
                                              {data.agentId}
                                            </h6> :
                                              <h6>
                                                <span>
                                                  {" "}
                                                  {data.createdOn
                                                    .replace("T", " ")
                                                    .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>
                                              }
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div class="txntxt">
                                              <h4>
                                                ₹ {data.transaction.amount}{" "}
                                              </h4>
                                              <h4>
                                                {" "}
                                                <span
                                                  class={`${
                                                    data.status === "SUCCESS"
                                                      ? "success"
                                                      : `${
                                                          data.status ===
                                                            "PENDING" ||
                                                          data.status ===
                                                            "PROCESSING" ||
                                                          data.status ===
                                                            "HUNG" ||
                                                          data.status ===
                                                            "ACCEPTED"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data.status}
                                                </span>
                                              </h4>
                                            </div>
                                          </div>
                                          <div class= {`col-12  ${((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? "col-md-2" : "col-md-1"} float-right`}>
                                        <div class="txntxt">
                                        {isSuperAdmin(id) &&  <button type="button"  style={{float:'right', backgroundColor:'rgb(159, 166, 178)'}} className="btn dbbtn" onClick={()=>showAllData(data)} ><i class="bi bi-eye-fill"></i> Logs</button>}
                                        {((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) &&
                                                <h6 style={{float:'right'}} >
                                                <span>
                                                  {" "}
                                                  {data.createdOn
                                                    .replace("T", " ")
                                                    .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>
                                              }
                                        </div>
                                      </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {showDetails.show &&
                                    showDetails.indexs === index && (
                                      <>
                                        <div class="txn-details">
                                          <div class="row">
                                            <div class="col-6 col-md-5">
                                              <div class="txnid">
                                                <h6>Account Nubmer</h6>
                                                <p>{maskAllButLastFour}</p>
                                              </div>
                                            </div>
                                            <div class="col-6 col-md-4">
                                              <div class="txnid srtxt">
                                                <h6>IFSC Code</h6>
                                                <p>
                                                  {
                                                    data?.beneficiary?.account
                                                      ?.ifsc
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                              <div class="txnid text-md-end">
                                                <h6>Sender Details</h6>
                                                <p>
                                                  {data?.beneficiary?.name} -{" "}
                                                  {data?.beneficiary?.mobile}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="txndtls">
                                          <div class="ordertxn">
                                            <div class="subtxn">
                                              <h4>Sub Transactions</h4>

                                              {Array.isArray(data?.subOrders) &&
                                                data?.subOrders.map(
                                                  (val, ind) => {
                                                    {
                                                      //console.log("val", val);
                                                    }

                                                    orderAmount =
                                                      orderAmount +
                                                      val?.txnDetails?.amount;
                                                    orderSurcharge =
                                                      orderSurcharge +
                                                      val?.txnDetails.surcharge;
                                                    if (
                                                      val.status === "SUCCESS"
                                                    ) {
                                                      transactionAmount =
                                                        transactionAmount +
                                                        val?.txnDetails?.amount;
                                                      transactionSurcharge =
                                                        transactionSurcharge +
                                                        val?.txnDetails
                                                          .surcharge;
                                                    }
                                                    return val.status ===
                                                      "SUCCESS" ? (
                                                      <div class="subtxn-success">
                                                        <div class="row">
                                                          <div class="col-6 col-md-3 col-lg-3 order-md-1">
                                                            <div class="subtxt txnsts">
                                                              Successfully
                                                            </div>
                                                          </div>

                                                          <div class="col-6 col-md-2 col-lg-3 order-md-4">
                                                            <div class="subtxt subamunt text-end">
                                                              ₹{" "}
                                                              {
                                                                val?.txnDetails
                                                                  ?.amount
                                                              }
                                                            </div>
                                                          </div>

                                                          <div class="col-12 col-md-4 col-lg-3 order-md-2">
                                                            <div class="subtxt subid">
                                                              Transaction ID:{" "}
                                                              {val?.id}
                                                            </div>
                                                          </div>

                                                          <div class="col-12 col-md-3 col-lg-3 order-md-3">
                                                            <div class="subtxt">
                                                              {val.createdOn !==
                                                                undefined &&
                                                                val.createdOn !==
                                                                  null &&
                                                                val.createdOn
                                                                  .replace(
                                                                    "T",
                                                                    " "
                                                                  )
                                                                  .slice(0, -4)}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : val.status ===
                                                      "FAILED" ? (
                                                      <div class="subtxn-failed">
                                                        <div class="row">
                                                          <div class="col-6 col-md-3 col-lg-3 order-md-1">
                                                            <div class="subtxt txnsts">
                                                              Failed
                                                            </div>
                                                          </div>

                                                          <div class="col-6 col-md-2 col-lg-3 order-md-4">
                                                            <div class="subtxt subamunt text-end">
                                                              ₹{" "}
                                                              {
                                                                val?.txnDetails
                                                                  ?.amount
                                                              }
                                                            </div>
                                                          </div>

                                                          <div class="col-12 col-md-4 col-lg-3 order-md-2">
                                                            <div class="subtxt subid">
                                                              Transaction ID:{" "}
                                                              {val?.id}
                                                            </div>
                                                          </div>

                                                          <div class="col-12 col-md-3 col-lg-3 order-md-3">
                                                         
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : val.status ===
                                                      "PENDING" ? (
                                                      <div class="subtxn-pending">
                                                        <div class="row">
                                                          <div class="col-6 col-md-3 col-lg-3 order-md-1">
                                                            <div class="subtxt txnsts">
                                                              Pending
                                                            </div>
                                                          </div>

                                                          <div class="col-6 col-md-2 col-lg-3 order-md-4">
                                                            <div class="subtxt subamunt text-end">
                                                              ₹{" "}
                                                              {
                                                                val?.txnDetails
                                                                  ?.amount
                                                              }
                                                            </div>
                                                          </div>

                                                          <div class="col-12 col-md-4 col-lg-3 order-md-2">
                                                            <div class="subtxt subid">
                                                              Transaction ID:{" "}
                                                              {val?.id}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    );
                                                  }
                                                )}
                                            </div>
                                          </div>

                                          <div class="ordertxn">
                                            <div class="row">
                                              <div class="col-12 col-sm-6">
                                                <div class="orderdetail">
                                                  <div class="odramt">
                                                    <p>
                                                      Order Amount{" "}
                                                      <span>
                                                        ₹ {orderAmount}
                                                      </span>
                                                    </p>
                                                    <p>
                                                      Surchage{" "}
                                                      <span>
                                                        ₹ {orderSurcharge}
                                                      </span>
                                                    </p>
                                                  </div>
                                                  <div class="ttlamt">
                                                    <p>
                                                      Total Amount{" "}
                                                      <span>
                                                        ₹{" "}
                                                        {+orderAmount +
                                                          +orderSurcharge}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-6">
                                                <div class="tnsfrdetail">
                                                  <div class="odramt">
                                                    <p>
                                                      Transaction Amount{" "}
                                                      <span>
                                                        ₹ {transactionAmount}
                                                      </span>
                                                    </p>
                                                    <p>
                                                      Surchage{" "}
                                                      <span>
                                                        ₹ {transactionSurcharge}
                                                      </span>
                                                    </p>
                                                  </div>
                                                  <div class="ttlamt">
                                                    <p>
                                                      Total Amount{" "}
                                                      <span>
                                                        ₹{" "}
                                                        {+transactionAmount +
                                                          +transactionSurcharge}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                </div>
                              );
                            })
                          )}
                          <div class="pager">
                            {table !== undefined &&
                              table !== null &&
                              table.length > 0 &&
                              search == "" && (
                                <p>
                                {paginationDetails.currentPage !== undefined && paginationDetails.currentPage !== null  && paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null &&  table !== undefined && Array.isArray(table) && setpageContent(paginationDetails.currentPage - 1, table.length, paginationDetails.totalPost)}
                                  <button
                                    class={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export
                                  </button>
                                </p>
                              )}

                            {
                              paginationDetails.totalPost !== undefined &&
                                paginationDetails.totalPost !== null &&
                                paginationDetails.totalPost > 10 &&
                                search == "" && (
                                  <Pagination
                                    className="pagination-bar"
                                    currentPage={paginationDetails.currentPage}
                                    totalCount={paginationDetails.totalPost}
                                    pageSize={paginationDetails.postsPerPage}
                                    onPageChange={(page) =>
                                      handalpageclick(page)
                                    }
                                  />
                                )
                              
                            }
                          </div>
                         
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="mobi-grap"
                    role="tabpanel"
                    aria-labelledby="mobi-grap-tab"
                  >
                    {/* <TransactionGraph/>  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default Payoutservice;
